module.exports = __webpack_public_path__ + "img/step3-c.8e5caf41.png";